import { create } from 'zustand';
import type { StateCreator } from 'zustand';
import { immer } from 'zustand/middleware/immer';

// Helper to create Zustand stores with Immer enabled and proper typing
export const createImmerStore = <T>(
  creator: StateCreator<
    T,
    [['zustand/immer', never]],
    []
  >
) => create<T>()(immer(creator));
